import { Inject, Injectable } from '@angular/core';
import { Title as NgTitle } from '@angular/platform-browser';
import { SITE_NAME } from '@freelancer/config';

/**
 * A service that can be used to set the title of the current HTML document.
 *
 * This wraps Angular's native Title service in order to ensure the titles
 * consistency, i.e. mostly append the site name to the titles for now.
 */

@Injectable({
  providedIn: 'root',
})
export class Title {
  constructor(
    private titleService: NgTitle,
    @Inject(SITE_NAME) private siteName: string,
  ) {}

  /**
   * Allows to set the page title.
   */
  setTitle(newTitle: string) {
    this.titleService.setTitle(`${newTitle} | ${this.siteName}`);
  }

  /*
   * we explicitly don't want to re-export getTitle here as there should not
   * be any reason to.
   */

  /*
   * PRIVATE: only to be used by the Title component
   * this allows the title to be reset on navigations
   */
  setDefaultTitle() {
    this.titleService.setTitle(this.siteName);
  }
}
